<template>
    <v-dialog width="450px" v-model="isOpenAddBadgeDialog">
        <v-card elevation="4">
            <v-card-title class="d-flex justify-center">
                <h2 class="
                        d-flex
                        justify-center
                        font-weight-light
                        primary--text
                    ">
                    Creando Bonificación
                </h2>
            </v-card-title>
            <!-- <v-divider></v-divider> -->
            <!-- <v-card class="mx-6 py-2 px-4 my-1" outlined>
                <v-row class="pb-3 pt-2">
                    <h4 class="font-weight-light primary--text px-2">Mes al que aplica</h4>
                </v-row>
                <v-divider class="mx-n1"></v-divider>
                <v-row class="d-flex justify-center">
                    <v-col cols="12">
                        <v-menu
                            ref="menu"
                            v-model="menu"  
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="date"
                                    label="Fecha"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                type="month"
                                no-title
                                scrollable
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                >
                                    Cancelar
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(date)"
                                >
                                    Guardar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card> -->
            <v-card-text class="pa-1">
                <v-card class="mx-6 pt-2 px-4 my-1" outlined>
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Filtrar por Rol
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider>
                    <v-row no-gutters>
                        <v-select class="pa-4" :items="opciones.cuenta.rol" item-text="human" item-value="encoded"
                            v-model="rol" persistent-hint :hint="
                                rol.length
                                    ? 'Elimine los filtros para ver la selección completa'
                                    : ''
                            " multiple prepend-inner-icon="mdi-gamepad-outline" label="Elija un rol" clearable>
                            <template #item="{ item }">
                                {{ item.human }}
                            </template>
                            <template #selection="{ item }">
                                <v-chip small dark color="red lighten-1">{{
                                    item.human
                                    }}</v-chip>
                            </template>
                        </v-select>
                    </v-row>
                </v-card>
                <v-card class="mx-6 pt-2 px-4 my-1" outlined>
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Filtrar por Tipo
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider>
                    <v-row no-gutters>
                        <v-select class="pa-4" :items="opciones.cuenta.tipoComercial" item-text="human"
                            item-value="encoded" v-model="types" persistent-hint :hint="
                                types.length
                                    ? 'Elimine los filtros para ver la selección completa'
                                    : ''
                            " multiple prepend-inner-icon="mdi-filter" label="Elija un tipo" clearable>
                            <template #item="{ item }">
                                {{ item.human }}
                            </template>
                            <template #selection="{ item }">
                                <v-chip small dark color="orange lighten-1">{{
                                    item.human
                                    }}</v-chip>
                            </template>
                        </v-select>
                    </v-row>
                </v-card>
                <v-card class="mx-6 pt-2 px-4 my-1" outlined>
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Comerciales Seleccionados
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider>
                    <v-row no-gutters>
                        <v-autocomplete v-if="$store.getters['login/hasManagerPermission']" class="pa-4"
                            :items="comercialesFilter" v-model="selectedComerciales" item-text="nombreCompleto"
                            item-value="id" multiple prepend-inner-icon="mdi-account" :hint="
                                !selectedComerciales.length
                                    ? 'Selecciona los comerciales a los que se les establecerá este importe de bolsa para este periodo'
                                    : selectedComerciales.length +
                                      ' seleccionados'
                            " persistent-hint label="Comercial" clearable>
                            <template #item="{ item }">
                                <v-row>
                                    <v-col cols="9">
                                        {{ item.nombreCompleto }}
                                    </v-col>
                                    <v-col cols="3">
                                        <v-icon :color="
                                                estadoComercial[item.estado]
                                            " class="
                                                d-flex
                                                justify-center
                                                overline
                                            ">
                                            mdi-circle
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </template>
                            <template #selection="{ item }">
                                <v-chip small color="lime">{{
                                    item.nombreCompleto
                                    }}</v-chip>
                            </template>
                        </v-autocomplete>
                    </v-row>
                </v-card>
                <v-card class="mx-6 pt-2 px-4 my-1" outlined>
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Tipo de bolsa
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider>
                    <v-row no-gutters>
                        <v-select class="pa-4" :items="opciones.distribuidor.rewardType" v-model="tipoBolsa"
                            item-text="human" item-value="encoded" :hint="hintText(tipoBolsa)
                            " persistent-hint prepend-inner-icon="mdi-bag-personal" label="Tipo de bolsa">
                            <template #item="{ item }">
                                {{ item.human }}
                            </template>
                            <template #selection="{ item }">
                                <v-chip small dark color="blue lighten-1">{{
                                    item.human
                                    }}</v-chip>
                            </template>
                        </v-select>
                    </v-row>
                </v-card>
                <v-card class="mx-6 pt-2 px-4" outlined>
                    <v-row class="pb-3 pt-2">
                        <h4 class="font-weight-light primary--text px-2">
                            Cantidad de Bonificación
                        </h4>
                    </v-row>
                    <v-divider class="mx-n1"></v-divider>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field :error-messages="
                                    amount < 0 && submitClicked
                                        ? 'Seleccione un valor válido'
                                        : ''
                                " v-model="amount" label="Cantidad" type="number" :prepend-icon="
                                        ['BOLSA_VARIABLE', 'BOLSA_RECOMENDADOR'].includes(tipoBolsa)
                                        ? 'mdi-percent'
                                        : 'mdi-currency-eur'
                                "></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>
            </v-card-text>

            <v-card-actions class="justify-end">
                <v-tooltip bottom max-width="470px" color="grey darken-3">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn depressed :disabled="selectedComerciales.length < 1" color="success" @click="
                                submit();
                                close();
                            " v-bind="attrs" v-on="on">
                            Subir
                        </v-btn>
                    </template>
                    <v-row>
                        <v-col class="text-justify" cols="8">
                            Esta bolsa será establecida para el mes en curso.
                            Recuerde que las bolsas anteriores se desactivarán y
                            esta pasará a ser la vigente. Así pues, en caso de
                            haber alguna bolsa ya establecida para alguno de los
                            comerciales seleccionados en el mes actual esta será
                            sustituida.
                        </v-col>
                        <v-col cols="4" class="px-6 align-self-center">
                            <v-icon size="90" color="orange">
                                mdi-alert
                            </v-icon>
                        </v-col>
                    </v-row>
                </v-tooltip>
                <v-btn :disabled="isExporting" text color="red" @click="close()">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { estadoComercial } from '@/util/libUtil.js';

export default {
    name: 'AddBadgeDialog',
    data: () => ({
        submitClicked: false,
        types: [],
        rol: [],
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        amount: 0.0,
        selectedComerciales: [],
        tipoBolsa: 'BOLSA_VARIABLE',
        estadoComercial,
    }),
    methods: {
        hintText(tipoBolsa){
            let hint = '';
            switch (tipoBolsa) {
                case 'BOLSA_VARIABLE':
                    hint = 'Tipo de bolsa calculada según lo que vende el comercial'
                    break;
                case 'BOLSA_RECOMENDADOR':
                    hint = 'Tipo de bolsa calculada según la parte vendida de ofertas de recomendador, establecer a comerciales que no sean de tipo recomendador'
                    break;
                default:
                    hint = 'Tipo de bolsa de dinero fijo'
                    break;
            }
            return hint;
        },
        close() {
            (this.rol = []),
                (this.types = []),
                (this.amount = 0.0),
                (this.submitClicked = false),
                (this.selectedComerciales = []);
            this.isOpenAddBadgeDialog = false;
        },
        submit() {
            this.submitClicked = true;

            this.$store.dispatch('areaPersonal/calculadora/addBadge', {
                amount: this.amount,
                commercial_id_arr: this.selectedComerciales,
                reward_type: this.tipoBolsa,
            });
        },
    },
    computed: {
        comercialesFilter() {
            return this.rol.length == 0 && this.types.length == 0
                ? this.comerciales
                : this.comerciales.filter(
                      (comercial) =>
                          this.rol.some((rol) => rol == comercial.rol?.id) ||
                          this.types.some(
                              (type) => type == comercial.tipoComercial
                          )
                  );
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        isOpenAddBadgeDialog: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .isOpenAddBadgeDialog;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenAddBadgeDialog',
                    value
                );
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState('util', {
            exportingProgress: (state) => state.exportingProgress,
            isExporting: (state) => state.isExporting,
            // opciones: (state) => state.opciones,
        }),
    },
};
</script>
